<template>
    <div class="card" v-show="loaded">

        <div class="card-header border-0">
            <div class="row">
                <div class="col-12">
                    <h3 class="mb-0 text-uppercase">{{ $t('common.competencies') }}</h3>
                </div>
            </div>
        </div>

        <p class="card-body pt-0 text-sm" v-if="empty">{{ $t('competencies.no-competency') }}</p>

        <div v-if="!empty">
            
            <table-control :paging="ctrl.paging" :search="true" v-model="search"></table-control>

            <el-table class="table-responsive table-flush"
                    :show-header="false"
                    :data="ctrl.rows">

                <el-table-column :label="$t('common.name')">
                    <template v-slot="{row}">
                        <h4 class="mb-0">
                            {{ row['name_' + grid.lang] }}
                        </h4>
                    </template>
                </el-table-column>

                <el-table-column align="right" class-name="actions" width="80" v-if="canAdd">
                    <template v-slot="{row}">

                        <a href="#" class="table-action text-primary"
                                @click.prevent="addCompetency(row)"
                                v-if="!row.selected">
                            <i class="tim-icons icon-e-add"></i>
                        </a>

                    </template>
                </el-table-column>
                
            </el-table>

            <table-pagination :paging="ctrl.paging"></table-pagination>
        </div>

        <portal to="modals">

            <form-modal v-model="modals.editCompetency"
                :title="selectedCompetency['name_' + grid.lang]"
            >
                <competency-form v-model="form.data"
                    :errors="form.errors"
                    :modal="modals.editCompetency"
                >
                </competency-form>
            </form-modal>

        </portal>
    </div>
</template>

<script>
    import CrudController from '@trax/classes/CrudController'
    import ModalsController from '@trax/classes/ModalsController'
    import CrudForm from '@trax/classes//CrudForm'
    import CompetencyMapping from './CompetencyMapping'
    import GridCompetenciesClient from './GridCompetenciesClient'
    import CompetencyForm from './GridCompetencyForm'

    export default {

        components: {
            CompetencyForm
        },

        props: {
            grid: {
                type: Object,
                required: true
            },
        },

        data() {
            let mapping = new CompetencyMapping()
            let client = new GridCompetenciesClient('/astral/api/front/grids/'+this.$route.params.id+'/competencies')
            return {
                loaded: false,
                mapping,
                ctrl: new CrudController({
                    endpoint: '/astral/api/front/competencies',
                    mapData: mapping.mapData,
                    unmapData: mapping.unmapData,
                    paging: {
                        perPage: 10,
                        total: 0
                    },
                    query: {
                        sort: ['position'],
                        filters: { active: true }
                    }
                }),
                search: '',
                selectedCompetency: {},
                modals: new ModalsController('editCompetency'),
                form: new CrudForm(client),
                client,
            }
        },

        created() {
            this.ctrl.mapData = this.mapData
            this.ctrl.init(this, 'ctrl').then(resp => {
                this.loaded = true
                this.$emit('ready')
            })
            this.form.init(this, 'form')
            this.modals.init(this, 'modals')
        },

        computed: {

            canAdd() {
                return this.grid.status != 'active' && this.grid.status != 'archived'
            },

            empty() {
                return this.ctrl.rows.length ==0 && !this.search
            }
        },

        watch: {
            search(val) {
                let filters = {}
                filters['name_' + this.grid.lang] = {$text: val}
                this.ctrl.filterMore(filters)
            },
            
            grid(val) {
                this.ctrl.rows.forEach(row => {
                    row.selected = this.isSelected(row)
                });
            }
        },

        methods: {

            mapData(competency) {
                let row = this.mapping.mapData(competency)
                row.selected = this.isSelected(competency)
                return row
            },

            isSelected(competency) {
                return this.grid.competencies.find(gridCompetency => gridCompetency.id == competency.id) != undefined
            },

            addCompetency(competency) {
                this.selectedCompetency = competency
                this.modals.open('editCompetency')
                this.form.create({
                    id: null,
                    description: '',
                    competency_id: competency.id,
                })
                .then(resp => {
                    this.modals.close('editCompetency')
                    this.$emit('change')
                })
            },
        }
    }
</script>

<style scoped>

    .card >>> th,
    .card >>> td {
        padding-right: 0;
    }

    .card >>> th.actions,
    .card >>> td.actions {
        padding-right: 1.5rem;
    }

    .card >>> .table-control form {
        width: 100%;
    }

</style>
